module.exports = require("@swa-ui/core/src/DateSelector/CalendarSecondary.module.scss");